/**
 * FieldError Component
 *
 * Displays inline validation errors below form fields.
 * Accessible with aria-describedby linking to field.
 */

import { AlertCircle } from 'lucide-react';

interface FieldErrorProps {
  id: string;
  message?: string;
}

export function FieldError({ id, message }: FieldErrorProps) {
  if (!message) return null;

  return (
    <div
      id={id}
      className="flex items-start gap-2 mt-2"
      role="alert"
      aria-live="polite"
    >
      <AlertCircle
        className="h-4 w-4 text-red-600 flex-shrink-0 mt-0.5"
        aria-hidden="true"
      />
      <p className="text-sm text-red-600">
        {message}
      </p>
    </div>
  );
}
